import React from 'react'
import LibSwitch from 'react-switch'

const customSwitchStyles = {
    onColor: '#007ef9',
    onHandleColor: '#2693e6',
    handleDiameter: 30,
    uncheckedIcon: false,
    checkedIcon: false,
    boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.6)',
    activeBoxShadow: '0px 0px 1px 10px rgba(0, 0, 0, 0.2)',
    height: 10,
    width: 24,
    handleDiameter: 18,
}

const Switch = function Switch(props) {
    return <LibSwitch {...props} {...customSwitchStyles} />
}

export default Switch
